import { createListFilters, IOption } from 'app/components'

export type ExamesFilters = {
  /** Nome do exame (busca parcial). */
  nome: string
  situacao?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ExamesFilters>({
  nome: '',
  situacao: undefined,
})
